export const TimePrecision = {
  MILLISECOND: "millisecond" as const,
  MINUTE: "minute" as const,
  SECOND: "second" as const,
  HOUR: "hour" as const,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TimePrecision = (typeof TimePrecision)[keyof typeof TimePrecision];
